const Input = {
  defaultProps: { bgColor: "white" },
  baseStyle: { bgColor: "white" },
};

export default Input;
